import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Play } from "lucide-react";

export default function Auth({ mode = "login" }) {
  const { login, register } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [username, setUsername] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      if (mode === "login") await login(email, pw);
      else await register({ email, password: pw, username });
      nav("/");
    } catch (er) { setErr(apiErr(er)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-[100dvh] gradient-hero flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <span className="w-10 h-10 rounded-xl bg-[#08D9D6] flex items-center justify-center">
            <Play size={20} className="text-black fill-black translate-x-[1px]"/>
          </span>
          <span className="h-font text-2xl font-extrabold">Jixxeo</span>
        </Link>
        <h1 className="h-font text-3xl font-bold">{mode==="login"?"Welcome back":"Create your account"}</h1>
        <p className="text-white/60 mt-1 text-sm">{mode==="login"?"Sign in to like, comment, upload, and earn coins.":"Join Jixxeo to watch, upload, and cash out coins."}</p>
        <form onSubmit={submit} className="mt-6 space-y-3" data-testid={`${mode}-form`}>
          {mode==="register" && (
            <input value={username} onChange={e=>setUsername(e.target.value)} placeholder="Username" required minLength={2}
                   data-testid="register-username"
                   className="w-full h-12 rounded-xl bg-white/5 border border-white/10 px-4 focus:outline-none focus:border-[#08D9D6]"/>
          )}
          <input value={email} onChange={e=>setEmail(e.target.value)} type="email" placeholder="Email" required
                 data-testid={`${mode}-email`}
                 className="w-full h-12 rounded-xl bg-white/5 border border-white/10 px-4 focus:outline-none focus:border-[#08D9D6]"/>
          <input value={pw} onChange={e=>setPw(e.target.value)} type="password" placeholder="Password" required minLength={6}
                 data-testid={`${mode}-password`}
                 className="w-full h-12 rounded-xl bg-white/5 border border-white/10 px-4 focus:outline-none focus:border-[#08D9D6]"/>
          {err && <div className="text-sm text-[#FF2E63]" data-testid="auth-error">{err}</div>}
          <button disabled={busy} type="submit" data-testid={`${mode}-submit`}
                  className="jx-btn w-full h-12 rounded-xl bg-[#08D9D6] text-black font-bold disabled:opacity-50 hover:bg-[#06B2B0]">
            {busy ? "Please wait…" : (mode==="login"?"Sign in":"Create account")}
          </button>
        </form>
        <div className="text-sm text-white/60 mt-6 text-center">
          {mode==="login" ? <>New to Jixxeo? <Link to="/register" className="text-[#08D9D6] font-semibold">Create account</Link></>
                          : <>Already have an account? <Link to="/login" className="text-[#08D9D6] font-semibold">Sign in</Link></>}
        </div>
      </div>
    </div>
  );
}
